/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import ReactSelect from 'react-select';
import { Option } from '../SelectInput/SelectInput';

type ReactSelectInputProps = {
  className?: string;
  name: string;
  id?: string;
  disabled?: boolean;
  error?: boolean;
  placeholder?: string;
  value: Option | string | number;
  options: Option[];
  onChange: (option: any) => void;
  onBlur?: (event: any) => void;
  styles?: any;
  [x: string]: any;
};

function ReactSelectInput({
  className,
  name,
  id,
  disabled,
  error,
  placeholder,
  value,
  onChange,
  onBlur,
  options,
  styles,
  ...props
}: ReactSelectInputProps) {
  const customStyles = {
    menuList: (provided: any) => ({
      ...provided,
      fontSize: 16,
    }),
    ...(styles && { ...styles }),
  };

  return (
    <ReactSelect
      {...props}
      className={`react-select-tailwind-container ${className} ${
        error ? 'border-pos-red' : ''
      }`}
      classNamePrefix="react-select-tailwind"
      id={id}
      name={name}
      placeholder={placeholder}
      value={value}
      isDisabled={disabled}
      onChange={!disabled ? onChange : undefined}
      onBlur={onBlur}
      options={options as any}
      styles={customStyles}
      theme={theme => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary25: '#ddf4ff',
          primary: '#2FAEF3',
        },
      })}
    />
  );
}

ReactSelectInput.defaultProps = {
  className: '',
  placeholder: '',
  onBlur: undefined,
  styles: undefined,
  id: undefined,
  disabled: false,
  error: false,
};

export default ReactSelectInput;
